import './TerminologyOverlay.css';
export var TerminologyTriggerCSS = '_2qz9rm0-2-0-1';